import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { IPaymentClaim } from 'types/Payment';
import { sortingDirections as sorting } from '../types/Form';

export const useSortedClaim = () => {
	const { paymentDetails } = useSelector((store: RootState) => store.payment);
	const { sortingFields, sortingDirections } = useSelector(
		(store: RootState) => store.form,
	);

	const sortPaymentClaimsFunction = useCallback(
		(a: IPaymentClaim, b: IPaymentClaim) => {
			switch (sortingDirections) {
				case sorting.ASC:
					return (
						(a[sortingFields as keyof IPaymentClaim] as number) -
						(b[sortingFields as keyof IPaymentClaim] as number)
					);
				case sorting.DESC:
					return (
						(b[sortingFields as keyof IPaymentClaim] as number) -
						(a[sortingFields as keyof IPaymentClaim] as number)
					);
				default:
					return 0;
			}
		},
		[sortingFields, sortingDirections],
	);

	if (paymentDetails.paymentClaims.length === 0)
		return paymentDetails.paymentClaims;

	return [...paymentDetails.paymentClaims].sort((a, b) =>
		sortPaymentClaimsFunction(a, b),
	);
};
